import { useTranslationLoadingContext } from '@/contexts/TranslationLoadingContext';

export function useTranslationWithLoading() {
	const { isTranslating, setIsTranslating } = useTranslationLoadingContext();

	const withTranslationLoading = async <T,>(
		translationFn: () => Promise<T>,
		options?: { loadingMessage?: string; successMessage?: string }
	): Promise<T> => {
		setIsTranslating(true);

		try {
			const result = await translationFn();
			return result;
		} catch (error) {
			throw error;
		} finally {
			setIsTranslating(false);
		}
	};

	return { isTranslating, withTranslationLoading };
}
